import { action } from "typesafe-actions";

import { message } from "antd";

import {
  DateRangePayload,
  GatePayload,
  OrderingPayload,
  PaginatedResponse,
  PaginationPayload,
  ReportPayload,
  ResolutionPayload,
} from "../common_types";
import { MarketPayload } from "../markets/types";

import {
  ConversionBaseItem,
  ConversionChartItem,
  ConversionChartsPayload,
  ConversionItem,
  ConversionsActionTypes,
  ConversionSearchResultChartItem,
} from "./types";

export const tableFetchRequest = (
  payload: ResolutionPayload & MarketPayload & DateRangePayload & PaginationPayload & GatePayload & OrderingPayload
) => action(ConversionsActionTypes.TABLE_FETCH_REQUEST, payload);

export const tableSummaryFetchRequest = (payload: MarketPayload & DateRangePayload & GatePayload) =>
  action(ConversionsActionTypes.TABLE_SUMMARY_FETCH_REQUEST, payload);

export const tableFetchSuccess = (payload: PaginatedResponse<ConversionItem>) =>
  action(ConversionsActionTypes.TABLE_FETCH_SUCCESS, payload);

export const tableSummaryFetchSuccess = (payload: ConversionBaseItem) =>
  action(ConversionsActionTypes.TABLE_SUMMARY_FETCH_SUCCESS, payload);

export const conversionsTableFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ConversionsActionTypes.TABLE_FETCH_ERROR);
};

export const conversionsSummaryTableFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ConversionsActionTypes.TABLE_SUMMARY_FETCH_ERROR);
};

export const chartFetchRequest = (
  payload: ResolutionPayload & MarketPayload & DateRangePayload & ConversionChartsPayload & GatePayload
) => action(ConversionsActionTypes.CHART_FETCH_REQUEST, payload);

export const chartFetchSuccess = (payload: { items: ConversionChartItem[] }) =>
  action(ConversionsActionTypes.CHART_FETCH_SUCCESS, payload);

export const conversionsChartFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ConversionsActionTypes.CHART_FETCH_ERROR);
};

export const chartSearchResultsFetchRequest = (
  payload: ResolutionPayload & MarketPayload & DateRangePayload & GatePayload
) => action(ConversionsActionTypes.CHART_SEARCH_RESULTS_FETCH_REQUEST, payload);

export const chartSearchResultsFetchSuccess = (payload: { items: ConversionSearchResultChartItem[] }) =>
  action(ConversionsActionTypes.CHART_SEARCH_RESULTS_FETCH_SUCCESS, payload);

export const chartSearchResultsFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ConversionsActionTypes.CHART_SEARCH_RESULTS_FETCH_ERROR);
};

export const reportGeneratorTaskCreateRequest = (
  payload: ReportPayload & MarketPayload & ResolutionPayload & DateRangePayload & GatePayload & OrderingPayload
) => action(ConversionsActionTypes.GENERATE_REPORT_REQUEST, payload);
